import { t } from "i18next";
import { useCurrentDataContext } from "../../../contexts/CurrentDataContext";
import { Employee } from "../../../contexts/interfaces";
import FormAccomplishments from "../FormAccomplishments/FormAccomplishments";
import classes from "./FormChosenEmployee.module.css";
import { convertDate } from "../../../utils/convertDate";
import FormAccomplishmentsUseAttachment from "../FormAccomplishments/UseAttachment/FormAccomplishmentsUseAttachment";
import FormAccomplishmentsUseAttachmentComplete from "../FormAccomplishments/UseAttachment/Complete/FormAccomplishmentsUseAttachmentComplete";
import FormEmployeeNameAndBirth from "../FormEmployeeNameAndBirth/FormEmployeeNameAndBirth";

interface Props {
  employee: Employee;
  formSubmitHandler: (
    e: React.SyntheticEvent<HTMLFormElement> | undefined,
    step: string,
    unfinished?: string | undefined
  ) => void;
}

const FormChosenEmployee = ({ employee, formSubmitHandler }: Props) => {
  const { currentData } = useCurrentDataContext();

  const handleClick = () => {
    // As user is going change user, save current data and
    // then redirect user to empty form page with employee search
    currentData?.formStatus &&
      formSubmitHandler(undefined, currentData.formStatus, "unfinishedStay");
  };

  return (
    <div className={classes.chosenEmployeeContainer}>
      <div className={classes.applicantContainer}>
        <div className={classes.topRow}>
          {`${t("formChosenEmployee.applicant")}`}
          {currentData?.formStatus !== "waiting" && (
            <button
              className={classes.editButton}
              onClick={() => handleClick()}
            >
              {`${t("formEducation.editButton")}`}
            </button>
          )}
        </div>
        <div className={classes.lowerContainer}>
          <FormEmployeeNameAndBirth
            firstName={employee.firstName}
            lastName={employee.lastName}
            dateOfBirth={convertDate(employee.dateOfBirth)}
          />

          <FormAccomplishments
            employeeAccomplishments={employee.accomplishments}
            showOnlyRequired={false}
            checkFormData={true}
          />
          {currentData?.formStatus !== "waiting" ? (
            <FormAccomplishmentsUseAttachment />
          ) : (
            <FormAccomplishmentsUseAttachmentComplete />
          )}
        </div>
      </div>
    </div>
  );
};

export default FormChosenEmployee;
